import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

export const TiptapMentionList = forwardRef((props, ref) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const itemRefs = useRef([]);

    const selectItem = (item) => {
        props?.command(item);
    };

    const upHandler = () => {
        setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
    };

    const downHandler = () => {
        setSelectedIndex((selectedIndex + 1) % props.items.length);
    };

    const enterHandler = () => {
        selectItem(props.items[selectedIndex]);
    };

    useEffect(() => setSelectedIndex(0), [props.items]);

    useEffect(() => {
        const el = itemRefs.current[selectedIndex];
        if (el) {
            el.scrollIntoView({ block: 'nearest' });
        }
    }, [selectedIndex]);

    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                upHandler();
                return true;
            }
            if (event.key === 'ArrowDown') {
                downHandler();
                return true;
            }
            if (event.key === 'Enter') {
                enterHandler();
                return true;
            }
            return false;
        },
    }));

    if (!props?.items?.length) {
        return null;
    }

    return (
        <div className="tiptap-mention-list">
            {props?.items.map((item, index) => (
                <button
                    ref={(el) => (itemRefs.current[index] = el)}
                    className={`tiptap-mention-item ${index === selectedIndex ? 'is-selected' : ''}`}
                    key={item.defaultValue || index}
                    onClick={() => selectItem(item)}
                    type="button"
                >
                    {item.name || item.token}
                </button>
            ))}
        </div>
    );
});

TiptapMentionList.displayName = 'TiptapMentionList';
